<div class="image-text-block">
  <div *ngIf="block.data.image_url" class="image-text-block__image" [ngStyle]="{backgroundImage: block.data.image_url ? 'url(' + block.data.image_url + ')' : null}"></div>

  <div class="image-text-block__content">
    <h3 class="image-text-block__header" [innerHTML]="block.data.text ? block.data.text : block.data.heading" *ngIf="block.data.text"></h3>
    <h4 class="image-text-block__subheader" [innerHTML]="block.data.subheading" *ngIf="block.data.subheading"></h4>
    <p class="image-text-block__text" [innerHTML]="block.data.bodyText" *ngIf="block.data.bodyText"></p>
    <a href="{{block.data.link}}" class="btn btn-primary image-text-block__button" target="{{block.data.target}}" *ngIf="block.data.buttonText && block.data.link">{{block.data.buttonText}}</a>
  </div>
</div>
